import React, { useState, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import hljs from "highlight.js";
import "highlight.js/styles/tokyo-night-dark.css";

// Component to display code snippets
const SnippetDisplay = ({ snippets }) => {
    const codeRefs = useRef([]);
  
    useEffect(() => {
      codeRefs.current.forEach((code) => {
        if (code) {
          // Unset the highlighted attribute to allow re-highlighting
          delete code.dataset.highlighted;
          hljs.highlightElement(code);
        }
      });
    }, [snippets]);

    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopy = (code, index) => {
        navigator.clipboard.writeText(code).then(() => {
            setCopiedIndex(index);
            setTimeout(() => setCopiedIndex(null), 2000);
        });
    };

    hljs.configure({
        ignoreUnescapedHTML: true
    });
  
    return (
        <Container>
            {snippets.length > 0 ? (
                snippets.map((snippet, index) => (
                <div key={index}>
                    <pre 
                        style={{ 
                            position: "relative", 
                            textAlign: "left",     // ensure left alignment of text
                            whiteSpace: "pre",     // preserve original whitespace
                            padding: "1em",
                            borderRadius: "5px"
                        }}
                    >
                        <Button 
                            onClick={() => handleCopy(snippet.code, index)}
                            style={{
                                position: "absolute",
                                top: "14px",
                                right: "13px",
                                zIndex: "1"         // ensure the button is above the code block
                            }}
                            variant="secondary"
                        >
                            {copiedIndex === index ? "Copied!" : "Copy code"}
                        </Button>
                        <code
                            ref={(el) => (codeRefs.current[index] = el)}
                            className={snippet.language}
                        >
                            {snippet.code}
                        </code>
                    </pre>
                </div>
                ))
            ) : (
                <p>No snippets found.</p>
            )}
        </Container>
    );
};

export default SnippetDisplay;